import { Stack, Typography } from "@mui/material";
import { type FC } from "react";

import { CategoryChip } from "~/components/UI/CategoryChip";
import { PlatformIcons } from "~/components/UI/PlatformIcons";
import { ROUTES } from "~/constants/routing";
import type { IRelatedEvent } from "~/types/relatedEvent";
import { formatPercentageValue } from "~/utils/formatValue";

import * as Styled from "./RelatedEventCard.styles";

interface IRelatedEventCardProps {
  event: IRelatedEvent;
}

export const RelatedEventCard: FC<IRelatedEventCardProps> = ({ event }) => {
  const probability = formatPercentageValue(
    (event.currentProbability ?? 0) * 100
  );

  return (
    <Styled.Root to={ROUTES.event.createURL(event.slug)}>
      <Stack sx={{
        gap: 1
      }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1
          }}>
          <CategoryChip categoryId={event.category} interactive={false} />
          <PlatformIcons platforms={event.platforms} size={20} />
        </Stack>

        <Typography component="h3" variant="caption" sx={{
          fontWeight: 700
        }}>
          {event.h1}
        </Typography>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1
          }}>
          <Typography variant="caption" sx={{
            color: "text.secondary"
          }}>
            {event.leadingOutcome}
          </Typography>

          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              textAlign: "right"
            }}>
            {probability}
          </Typography>
        </Stack>
      </Stack>
    </Styled.Root>
  );
};
